import { adminApi } from './http';

const IMAGE_UPLOAD_TIMEOUT = 2 * 60 * 1000;
const ARTICLE_IMPORT_TIMEOUT = 10 * 60 * 1000;

export const fetchAdminPosts = (params = {}) => adminApi.get('/articles', { params });

export const createAdminPost = (payload) => adminApi.post('/articles', payload);

export const updateAdminPost = (id, payload) => adminApi.put(`/articles/${id}`, payload);

export const fetchAdminPostDetail = (id) => adminApi.get(`/articles/${id}`);

export const deleteAdminPost = (id) => adminApi.delete(`/articles/${id}`);

export const batchDeleteAdminPosts = (ids) => adminApi.post('/articles/batch-delete', { ids });

export const uploadAdminImage = (file) => {
  const formData = new FormData();

  formData.append('file', file);

  return adminApi.post('/uploads/images', formData, {
    timeout: IMAGE_UPLOAD_TIMEOUT,
  });
};

export const importAdminMarkdown = ({
  file,
  images = [],
  visible = true,
  categoryId = null,
}) => {
  const formData = new FormData();

  formData.append('file', file);
  images.forEach((image) => {
    const imageFile = image.file || image;
    const imagePath = image.path || imageFile.webkitRelativePath || imageFile.name;

    formData.append('images', imageFile, imagePath);
  });
  formData.append('visible', visible);

  if (categoryId) {
    formData.append('categoryId', Number(categoryId));
  }

  return adminApi.post('/articles/import-md', formData, {
    timeout: ARTICLE_IMPORT_TIMEOUT,
  });
};

export const importAdminDocx = ({ file, visible = true, categoryId = null }) => {
  const formData = new FormData();

  formData.append('file', file);
  formData.append('visible', visible);

  if (categoryId) {
    formData.append('categoryId', Number(categoryId));
  }

  return adminApi.post('/articles/import-docx', formData, {
    timeout: ARTICLE_IMPORT_TIMEOUT,
  });
};

export const importAdminPdf = ({ file, visible = true, categoryId = null }) => {
  const formData = new FormData();

  formData.append('file', file);
  formData.append('visible', visible);

  if (categoryId) {
    formData.append('categoryId', Number(categoryId));
  }

  return adminApi.post('/articles/import-pdf', formData, {
    timeout: ARTICLE_IMPORT_TIMEOUT,
  });
};
